<script setup lang="ts">
/**
 * This component handles the logic for rendering task attachment links
 */
import { Capacitor } from '@capacitor/core'
import { PDFsModel } from '../models/PDFsModel'
import { WriteFileOptions } from '@capacitor/filesystem'
import { generateFileNameFromURL } from '../models/PDFsModel'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useDevicePDFsStore } from '../store/useDevicePDFsStore'
import TableCellRender from './TableCellRender.vue'

const props = withDefaults(
  defineProps<{
    /**Filter data (use if isTable is true) */
    filterData: any
    /**The full attachment url. */
    attachment: string | null
    /**Shrinks the size for tables. Defaults to false. */
    truncate: boolean
  }>(),
  {
    truncate: false,
  }
)
const isNative = Capacitor.isNativePlatform()
const open = (src: WriteFileOptions['path']) => PDFsModel().openPDF(src)
const { getPDFs } = storeToRefs(useDevicePDFsStore())
const renderText = (url: string) => {
  return generateFileNameFromURL(url)
    .replaceAll('+Instructions', '')
    .replaceAll('InstructionFiles', '')
    .replaceAll('%', '')
}
const onDevice = computed(() => {
  if (!props.attachment) return false
  return getPDFs.value.includes(generateFileNameFromURL(props.attachment))
})
</script>
<template>
  <template v-if="attachment">
    <span
      v-if="isNative"
      :class="onDevice ? 'text-primary underline' : 'text-black'"
      class="ellipsis"
      :style="
        truncate ? 'max-width: 7em; display: block; direction: rtl; text-align: left' : undefined
      "
      @click="open(attachment)"
    >
      <TableCellRender :data="renderText(attachment)" data-type="string" :filter="filterData" />
    </span>
    <span
      v-else
      class="text-primary underline"
      target="_blank"
      rel="noopener noreferrer"
      :href="props.attachment"
    >
      <TableCellRender
        :data="generateFileNameFromURL(attachment)"
        data-type="string"
        :filter="filterData"
      />
    </span>
  </template>
</template>
